import { debounce as debounceFn } from 'js/lib/general-utils'
import 'js/lib/history' // imported to support listening to history changes
import { on } from 'js/lib/events'
import { onTimeout } from './timeout_listener.mjs'

export function useListener(listenerAst) {
  const listeners = walkAst(listenerAst)

  function onChange(callback) {
    const cleanupFns = listeners.map(listener => {
      const { eventName, selector, timeout, opts } = listener

      if (timeout) return onTimeout(timeout, callback)

      if (opts.debounce) callback = debounceFn(callback, opts.debounce)

      return on(eventName, selector, (event, matchedElement) => {
        if (opts.prevent_default) event.preventDefault()
        callback(event, matchedElement)
      })
    })

    return () => cleanupFns.forEach(fn => fn())
  }

  return {
    onChange,
    listeners,
  }
}

function walkAst(ast) {
  const [name] = ast
  if (name === 'listeners') return walkAskForList(ast)
  if (name === 'listener') return [walkAskForSingle(ast)]
  if (name === 'timeout') return [walkAstForTimeout(ast)]

  throw new Error('Cannot parse listener')
}

function walkAskForList(ast) {
  const [name, listeners] = ast
  if (name !== 'listeners') throw new Error('Cannot parse listener')
  return listeners.flatMap(walkAst)
}

function walkAskForSingle(ast) {
  const [name, eventName, selector, rawOpts] = ast
  if (name !== 'listener') throw new Error('Cannot parse listener')
  const opts = Object.fromEntries(new Map(rawOpts))
  return { eventName, selector, opts }
}

function walkAstForTimeout(ast) {
  const [name, timeout] = ast
  if (name !== 'timeout') throw new Error('Cannot parse timeout listener')

  return { timeout, opts: {} }
}
